'use client'
import { Tabs, Tab, Button } from "@heroui/react";
import CrouselBeforeAndAfterIndex from "./CrouselBeforeAndAfterIndex";
import { BeforeAndAfterHomeScrollabeDataEntity } from "@/types/GetBeforeAndAfterHomeScollableType";
import Link from "next/link";
import { useCallback, useRef, useState } from "react";

export interface TabsBeforeAndAfterIndexProps {
    beforeAndAfterGroupeData: BeforeAndAfterHomeScrollabeDataEntity[] | null | undefined
}

const TabsBeforeAndAfterIndex = ({ beforeAndAfterGroupeData }: TabsBeforeAndAfterIndexProps) => {

    const tabsRef = useRef<HTMLDivElement>(null);

    const tabItems = beforeAndAfterGroupeData?.map((curr, index) => {

        const tempCrouselData = curr?.beforeAfters?.map((item) => ({
            beforeImage: item?.afterImage?.url || '',
            afterImage: item?.beforeImage?.url || '',
            before_alt_name: item?.afterImage?.alt || 'before_image',
            after_alt_name: item?.beforeImage?.alt || 'after_image',
        })) || []

        return {
            key: curr?.treatment?._id || `before_after_${index + 1}`,
            title: curr?.treatment?.name || 'No Tag',
            content: <CrouselBeforeAndAfterIndex beforeAndAfterData={tempCrouselData} />,
        }
    }) || [];

    const [selectedKey, setSelectedKey] = useState<string | undefined>(tabItems[0]?.key);

    const handleSelectionChange = useCallback(
        (key: React.Key) => {
            setSelectedKey(key as string);
            const tabIndex = tabItems.findIndex((item) => item.key === key);
            if (tabIndex < 0) return;
            requestAnimationFrame(() => {
                const tablist = tabsRef.current?.querySelector('[role="tablist"]');
                const tabs = tablist?.querySelectorAll('[role="tab"]');
                const targetTab = tabs?.[tabIndex];
                if (targetTab) {
                    targetTab.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
                }
            });
        },
        [tabItems]
    );

    return (
        <div ref={tabsRef}>
            <Tabs
                key="light"
                aria-label="Tabs variants"
                variant="light"
                className="hero_tabs_parent"
                classNames={{
                    tab: "hero_single_tab",
                    tabContent: "hero_tab_content",
                    cursor: "hero_tab_cursor",
                    panel: 'px-0!'
                }}
                items={tabItems}
                selectedKey={selectedKey ?? tabItems[0]?.key}
                onSelectionChange={handleSelectionChange}
            >
                {(item) => (
                    <Tab key={item.key} title={item.title}>
                        {item?.content}
                    </Tab>
                )}
            </Tabs>
            <div className="flex justify-center">
                <Link href={'/gallery'}>
                    <Button className="btn_responsive_cta silverblue_border_btn" >View In Gallery</Button>
                </Link>
            </div>
        </div>
    )
}

export default TabsBeforeAndAfterIndex